import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6336b078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pricing-wrap" }
const _hoisted_3 = { class: "pricing-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "直邮运费计算规则", -1))
const _hoisted_5 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_6 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "默认运费", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元,每增加", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1))
const _hoisted_14 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa","margin-top":"20px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("包邮规则 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999"} }, "指定区域设置满X元包邮，满足包邮条件优先按照包邮计算，不满足时按照固定价格计算")
], -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "pricing-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "限售区域 ", -1))
const _hoisted_19 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "pricing-wrap" }
const _hoisted_22 = { class: "pricing-box" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "直邮运费计算规则", -1))
const _hoisted_24 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_25 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "固定价格", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "元", -1))
const _hoisted_28 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa","margin-top":"20px"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("包邮规则 "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999"} }, "指定区域设置满X元包邮，满足包邮条件优先按照包邮计算，不满足时按照固定价格计算")
], -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "pricing-box" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "限售区域 ", -1))
const _hoisted_33 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "pricing-wrap" }
const _hoisted_36 = { class: "pricing-box" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "包邮区域", -1))
const _hoisted_38 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_39 = { class: "pricing-box" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pricing-title-box" }, "限售区域 ", -1))
const _hoisted_41 = { style: {"padding":"10px","border":"1px dashed #ddd","background":"#fafafa"} }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_43 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_RuleItem = _resolveComponent("RuleItem")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                required: true,
                label: "规则名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入规则名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ui_form_item, { label: "运费类型" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.formData.postageType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.postageType) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode("阶梯计价")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode("固定运费")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("商家包邮")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.formData.postageType == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_ui_form_item, { label: "计价方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.pricingType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.pricingType) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode("按件数")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("重量")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ui_form_item, { label: "计价方式" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_RuleItem, {
                                  modelValue: _ctx.formData.area,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.area) = $event)),
                                  disabledList: _ctx.formData.banArea
                                }, null, 8, ["modelValue", "disabledList"]),
                                _createElementVNode("div", _hoisted_6, [
                                  _hoisted_7,
                                  _createVNode(_component_el_input, {
                                    placeholder: "请输入",
                                    style: {"width":"120px"},
                                    modelValue: _ctx.formData.firstNumber,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.firstNumber) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (_ctx.formData.pricingType == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "件以内"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "KG以内")),
                                  _createVNode(_component_el_input, {
                                    placeholder: "请输入",
                                    style: {"width":"120px"},
                                    modelValue: _ctx.formData.firstPrice,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.firstPrice) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_10,
                                  _createVNode(_component_el_input, {
                                    placeholder: "请输入",
                                    style: {"width":"120px"},
                                    modelValue: _ctx.formData.renewNumber,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.renewNumber) = $event))
                                  }, null, 8, ["modelValue"]),
                                  (_ctx.formData.pricingType == 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "件,增加运费"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "KG,增加运费")),
                                  _createVNode(_component_el_input, {
                                    placeholder: "请输入",
                                    style: {"width":"120px"},
                                    modelValue: _ctx.formData.renewPrice,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.renewPrice) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_13
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_RuleItem, {
                                  modelValue: _ctx.formData.targetArea,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.targetArea) = $event)),
                                  disabledList: _ctx.formData.banArea
                                }, null, 8, ["modelValue", "disabledList"]),
                                _createElementVNode("div", null, [
                                  _hoisted_15,
                                  (_ctx.formData.targetArea.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createTextVNode(" 满"),
                                        _createVNode(_component_el_input, {
                                          placeholder: "请输入",
                                          style: {"width":"120px","margin":"0 5px"},
                                          modelValue: _ctx.formData.freePrice,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.freePrice) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createTextVNode("元包邮 ")
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                              _hoisted_18,
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_RuleItem, {
                                  modelValue: _ctx.formData.banArea,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.banArea) = $event)),
                                  disabledList: _ctx.formData.area
                                }, null, 8, ["modelValue", "disabledList"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.formData.postageType == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_ui_form_item, { label: "计价方式" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _hoisted_23,
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_RuleItem, {
                                    modelValue: _ctx.formData.area,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.area) = $event)),
                                    disabledList: _ctx.formData.banArea
                                  }, null, 8, ["modelValue", "disabledList"]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createVNode(_component_el_input, {
                                      placeholder: "请输入",
                                      style: {"width":"120px"},
                                      modelValue: _ctx.formData.fixedPrice,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.fixedPrice) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_27
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_RuleItem, {
                                    modelValue: _ctx.formData.targetArea,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.targetArea) = $event)),
                                    disabledList: _ctx.formData.banArea
                                  }, null, 8, ["modelValue", "disabledList"]),
                                  _createElementVNode("div", null, [
                                    _hoisted_29,
                                    (_ctx.formData.targetArea.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _createTextVNode(" 满"),
                                          _createVNode(_component_el_input, {
                                            placeholder: "请输入",
                                            style: {"width":"120px","margin":"0 5px"},
                                            modelValue: _ctx.formData.freePrice,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.freePrice) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createTextVNode("元包邮 ")
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", null, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_RuleItem, {
                                    modelValue: _ctx.formData.banArea,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.banArea) = $event)),
                                    disabledList: _ctx.formData.area
                                  }, null, 8, ["modelValue", "disabledList"])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.formData.postageType == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_ui_form_item, { label: "计价方式" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", null, [
                                  _hoisted_37,
                                  _createElementVNode("div", _hoisted_38, [
                                    _createVNode(_component_RuleItem, {
                                      modelValue: _ctx.formData.area,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.area) = $event)),
                                      disabledList: _ctx.formData.banArea
                                    }, null, 8, ["modelValue", "disabledList"])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", null, [
                                  _hoisted_40,
                                  _createElementVNode("div", _hoisted_41, [
                                    _createVNode(_component_RuleItem, {
                                      modelValue: _ctx.formData.banArea,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.banArea) = $event)),
                                      disabledList: _ctx.formData.area
                                    }, null, 8, ["modelValue", "disabledList"])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}